import { gql } from "@apollo/client";

export const CREATE_SURVEY = gql`
    mutation CreateSurvey(
        $title: String!
        $description: String
        $isAnonymous: Boolean
        $vpReward: Int
        $targetType: String
        $status: String
        $endDate: DateTime
        $videoUrl: String
        $targetUserIds: [UUID]
    ) {
        createSurvey(
            title: $title
            description: $description
            isAnonymous: $isAnonymous
            vpReward: $vpReward
            targetType: $targetType
            status: $status
            endDate: $endDate
            videoUrl: $videoUrl
            targetUserIds: $targetUserIds
        ) {
            survey {
                id
                title
                status
            }
        }
    }
`;

export const UPDATE_SURVEY = gql`
    mutation UpdateSurvey(
        $id: UUID!
        $title: String
        $description: String
        $isAnonymous: Boolean
        $vpReward: Int
        $targetType: String
        $status: String
        $endDate: DateTime
        $videoUrl: String
        $targetUserIds: [UUID]
    ) {
        updateSurvey(
            id: $id
            title: $title
            description: $description
            isAnonymous: $isAnonymous
            vpReward: $vpReward
            targetType: $targetType
            status: $status
            endDate: $endDate
            videoUrl: $videoUrl
            targetUserIds: $targetUserIds
        ) {
            survey {
                id
                title
                status
            }
        }
    }
`;

export const DELETE_SURVEY = gql`
    mutation DeleteSurvey($id: UUID!) {
        deleteSurvey(id: $id) {
            success
        }
    }
`;

export const ACTIVATE_SURVEY = gql`
    mutation ActivateSurvey($id: UUID!) {
        activateSurvey(id: $id) {
            survey {
                id
                status
            }
        }
    }
`;

export const CLOSE_SURVEY = gql`
    mutation CloseSurvey($id: UUID!) {
        closeSurvey(id: $id) {
            survey {
                id
                status
            }
        }
    }
`;

export const ADD_SURVEY_QUESTION = gql`
    mutation AddSurveyQuestion(
        $surveyId: UUID!
        $text: String!
        $questionType: String!
        $isRequired: Boolean
        $order: Int
        $videoUrl: String
        $conditionalOnId: UUID
        $conditionalValue: String
    ) {
        addSurveyQuestion(
            surveyId: $surveyId
            text: $text
            questionType: $questionType
            isRequired: $isRequired
            order: $order
            videoUrl: $videoUrl
            conditionalOnId: $conditionalOnId
            conditionalValue: $conditionalValue
        ) {
            question {
                id
                text
                questionType
                isRequired
                order
            }
        }
    }
`;

export const UPDATE_SURVEY_QUESTION = gql`
    mutation UpdateSurveyQuestion(
        $id: UUID!
        $text: String
        $questionType: String
        $isRequired: Boolean
        $order: Int
        $videoUrl: String
        $conditionalOnId: UUID
        $conditionalValue: String
    ) {
        updateSurveyQuestion(
            id: $id
            text: $text
            questionType: $questionType
            isRequired: $isRequired
            order: $order
            videoUrl: $videoUrl
            conditionalOnId: $conditionalOnId
            conditionalValue: $conditionalValue
        ) {
            question {
                id
                text
                questionType
                isRequired
                order
            }
        }
    }
`;

export const DELETE_SURVEY_QUESTION = gql`
    mutation DeleteSurveyQuestion($id: UUID!) {
        deleteSurveyQuestion(id: $id) {
            success
        }
    }
`;

export const ADD_SURVEY_QUESTION_OPTION = gql`
    mutation AddSurveyQuestionOption(
        $questionId: UUID!
        $text: String!
        $order: Int
    ) {
        addSurveyQuestionOption(
            questionId: $questionId
            text: $text
            order: $order
        ) {
            option {
                id
                text
                order
            }
        }
    }
`;

export const UPDATE_SURVEY_QUESTION_OPTION = gql`
    mutation UpdateSurveyQuestionOption(
        $id: UUID!
        $text: String
        $order: Int
    ) {
        updateSurveyQuestionOption(id: $id, text: $text, order: $order) {
            option {
                id
                text
                order
            }
        }
    }
`;

export const DELETE_SURVEY_QUESTION_OPTION = gql`
    mutation DeleteSurveyQuestionOption($id: UUID!) {
        deleteSurveyQuestionOption(id: $id) {
            success
        }
    }
`;

export const SUBMIT_SURVEY_RESPONSE = gql`
    mutation SubmitSurveyResponse($surveyId: UUID!, $answers: [JSONString]!) {
        submitSurveyResponse(surveyId: $surveyId, answers: $answers) {
            response {
                id
                completedAt
                vpAwarded
            }
            vpEarned
        }
    }
`;

export const MARK_SURVEY_VIEWED = gql`
    mutation MarkSurveyViewed($surveyId: UUID!) {
        markSurveyViewed(surveyId: $surveyId) {
            success
        }
    }
`;

export const UPLOAD_SURVEY_IMAGE = gql`
    mutation UploadSurveyImage($surveyId: UUID, $questionId: UUID) {
        uploadSurveyImage(surveyId: $surveyId, questionId: $questionId) {
            imageUrl
            imageId
        }
    }
`;

export const DELETE_SURVEY_QUESTION_IMAGE = gql`
    mutation DeleteSurveyQuestionImage($id: UUID!) {
        deleteSurveyQuestionImage(id: $id) {
            success
        }
    }
`;
